import {getIntroduction} from "../../api/introduce";

const state = () => ({

  introduce:{},
})


const getters = {
  get_introduce(state) {
    return state.introduce;
  },
}

const mutations = {
  SET_INTRODUCE(state,data){
    state.introduce = data;}
}

const actions = {
  async fetchIntroduce({ commit }) {
    try {
      const response = await getIntroduction();
      commit('SET_INTRODUCE', response.data.results);
    } catch (error) {
      // handle the error here
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
